// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".flex[data-v-7b220f97]{-webkit-box-flex:1;-ms-flex:1;flex:1}.height-full[data-v-7b220f97]{height:100%}.transparentCard[data-v-7b220f97]{opacity:.8!important}#fillOutContentItemsList[data-v-7b220f97]  .max-height{max-height:calc(100vh - 225px);overflow-x:hidden}.greyBackgroundColor[data-v-7b220f97]{background-color:#f5f5f5!important}", ""]);
// Exports
module.exports = exports;
